import React from "react";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import { Card, CardContent, Stack, Typography, Link, Avatar } from "@mui/joy";
import TotalApplicants from "../../assets/svgs/totalapplicants.svg";

interface Applicant {
  fullName: string;
  userId?: string;
  applicants?: Array<{
    userId: string;
  }>;
}

interface ApplicantsListProps {
  applicants: Applicant[];
}

const ApplicantsList: React.FC<ApplicantsListProps> = ({ applicants }) => {
  const navigate = useNavigate();

  return (
    <Card>
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={1.5}
        >
          <Typography level="mediumHeading">People</Typography>
          <Link component={RouterLink} to="/admin/applicants">
            View all
          </Link>
        </Stack>

        <Stack
          spacing={1.5}
          sx={{
            height: { xs: "250px", sm: "320px" },
            overflowY: "auto",
            scrollbarWidth: "none",
          }}
        >
          {applicants?.map((applicant, index) => (
            <Stack
              key={index}
              direction="row"
              alignItems="center"
              spacing={1.5}
              pb={1.5}
              borderBottom={
                index < applicants.length - 1 ? "1px solid #eee" : "none"
              }
              onClick={() => {
                navigate(`/admin/applicants/${applicant?.applicants?.[0]?.userId}`);
              }}
              sx={{ cursor: "pointer" }}
            >
              <Avatar src={TotalApplicants} />
              <Typography level="description">{applicant?.fullName}</Typography>
            </Stack>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default ApplicantsList;
